import { createAppSlice } from 'app/createAppSlice'

const initialState = {
  tag: {
    size: 10,
    page: 0,
    search: undefined,
  },
}

export const eventPartnerSlice = createAppSlice({
  name: 'eventPartner',
  initialState,
  reducers: (create) => ({
    setFetchOption: create.reducer((state, { payload }) => {
      state.tag = { ...state.tag, ...payload }
    }),
  }),
  extraReducers: (builder) => {},
})

export const { setFetchOption } = eventPartnerSlice.actions

export default eventPartnerSlice.reducer
